export { default } from './TaskItemNewTasks';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListNewTasks/TaskItemNewTasks/index.js